import { getSentry } from "./sentry";

/** Report a handled boundary failure without native errors, tokens or payloads. */
export function reportOperationalError(
  operation:
    | "desktop_sign_in"
    | "desktop_auth_handoff"
    | "companion_start"
    | "companion_restart",
  error: unknown,
): void {
  const name =
    error instanceof Error || error instanceof DOMException
      ? error.name
      : "NativeCommandError";
  if (name === "AbortError" || name === "CancelledError") return;
  const sentry = getSentry();
  if (!sentry) return;
  try {
    sentry.captureException(new Error(`${operation} failed`), {
      tags: { layer: "desktop", operation, error_type: name },
      fingerprint: ["desktop", operation, name],
    });
  } catch {
    // Reporting must not interrupt auth or companion recovery UI.
  }
}
